import { Col, Container, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import PagesHeader from '../../../../../components/base/PagesHeader';
import useSpecialConditions from './useSpecialConditions';
import { CHILD_LEAVE_OPTIONS } from '../../constants';

import styles from '../../../../../assets/scss/6-pages/superAdmin/pension-policy/SpecialCondition.module.scss';
import { PolicyLeaveCategory } from '../../types';

const ParentalLeave = () => {
  const { t } = useTranslation();
  const { parentalLeave, handleToggleParentalLeavePolicy, handleChangeDaysLength } = useSpecialConditions();

  return (
    <div className={classNames('mb-3 parental-check-group', styles.sp_cond_group)}>
      <PagesHeader
        pageTitle={t('PENSION_POLICY.parental_leave')}
        translate={false}
        // subText={t('PENSION_POLICY.fixed_compensation_only')}
        subTextPosition="bottom"
      />
      <div className="d-flex align-items-end dark-content-section">
        <Container fluid>
          <Row className="w-100">
            <Col>
              <Form.Group className="pe-0">
                <Form.Check
                  inline
                  type="checkbox"
                  label={`${t('PENSION_POLICY.policy_valid_parental_leave')}`}
                  id="parentalLeaveIsChecked"
                  className="fs-name mb-1"
                  onChange={(e) => handleToggleParentalLeavePolicy('isChecked', e.target.checked)}
                  name="parentalLeaveisChecked"
                  defaultChecked={parentalLeave.isChecked}
                  checked={parentalLeave.isChecked}
                />
              </Form.Group>
            </Col>

            <Col sm="7">
              {parentalLeave.isChecked && (
                <>
                  <p className="fs-name">{t('PENSION_POLICY.policy_parts_included')}</p>

                  <div className={styles.sp_cond_parts}>
                    <div className={styles.sp_cond_parts__type}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label={t('PENSION_POLICY.premium_calculation')}
                          id="parentalLeaveisPremiumCalculation"
                          className={classNames('fs-name mb-1', styles.include_part)}
                          onChange={(e) => handleToggleParentalLeavePolicy('isPremiumCalculation', e.target.checked)}
                          name="parentalLeaveisPremiumCalculation"
                          defaultChecked={parentalLeave.isPremiumCalculation}
                          checked={parentalLeave.isPremiumCalculation}
                        />
                      </Form.Group>
                    </div>

                    <div className={styles.sp_cond_parts__type}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label={t('PENSION_POLICY.applicable_salary_change')}
                          id="iparentalLeavesSalaryChange"
                          className={classNames('fs-name mb-1', styles.include_part)}
                          onChange={(e) => handleToggleParentalLeavePolicy('isSalaryChange', e.target.checked)}
                          name="parentalLeaveisSalaryChange"
                          defaultChecked={parentalLeave.isSalaryChange}
                          checked={parentalLeave.isSalaryChange}
                        />
                      </Form.Group>
                    </div>

                    <div className={styles.sp_cond_parts__type}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label={t('insurances')}
                          id="parentalLeaveisInsurances"
                          className={classNames('fs-name mb-1', styles.include_part)}
                          onChange={(e) => handleToggleParentalLeavePolicy('isInsurances', e.target.checked)}
                          name="parentalLeaveisInsurances"
                          defaultChecked={parentalLeave.isInsurances}
                          checked={parentalLeave.isInsurances}
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <div className={styles.sp_other_opt}>
                    <Form.Group className={classNames(styles.child_leave_opt)}>
                      <Form.Label className="fs-name">
                        {`${t('PENSION_POLICY.max_length')} / ${t('PENSION_POLICY.child')}`}{' '}
                        <span className="font-weight-400">({t('PENSION_POLICY.days')})</span>
                      </Form.Label>
                      <Form.Select
                        value={parentalLeave.maximumLength === null ? '' : parentalLeave.maximumLength}
                        onChange={(e) =>
                          handleChangeDaysLength(PolicyLeaveCategory.PARENTAL, 'maximumLength', e.target.value)
                        }
                        name="parentalLeaveMaximumOpt"
                        style={{ width: 120 }}
                      >
                        <option value="" selected={parentalLeave.maximumLength === null ? true : false} disabled>
                          {t('none')}
                        </option>
                        {CHILD_LEAVE_OPTIONS.map((item) => {
                          return (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ParentalLeave;
